export const filterChipClasses = {
  active: 'active',
}
